export default "__VITE_ASSET__DZZlRrTZ__"